export default function areEqual(array1?: string[], array2?: string[]): boolean {
    const first = array1 ?? [];
    const second = array2 ?? [];

    if (first.length === second.length) {
        return first.every((element) => second.includes(element));
    }

    return false;
}

export const isEmpty = (value) => {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else if (value && typeof value === 'object') {
        return Object.keys(value).length === 0;
    }
    return !value; // Handles null, undefined, or falsy values
};

// To replace Lodash one cause it's a copy of it
// export const isObject = (value) => {
//     const type = typeof value;
//     return value != null && (type == 'object' || type == 'function');
// };
